// @flow
import { PRODUCT_COMMUNITY_QUESTIONS } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_COMMUNITY_QUESTIONS } from 'Utils/request/requestDictionary';
import { type ProductCommunityQuestionsDescriptorProps } from 'Components/lines/product-community-questions-line/productCommunityQuestionsLine.utils';

export const productCommunityQuestionsResolver = {
  name: PRODUCT_COMMUNITY_QUESTIONS,
  resolve(
    appContext: AppContext,
    props: ProductCommunityQuestionsDescriptorProps,
    pageContext: PageContext,
    location: ProductRouterLocation,
  ) {
    const { urlParams } = location;
    const { resortId: productId } = props;
    const productArgs = buildProductArgs(productId, urlParams);
    const query = `query {
      config {
        common { close next previous scrollBackward scrollForward }
      }
      productCommunity(${productArgs}) {
        linkAllQuestionsUrl
        questions {
          id
          likesCount
          authorName
          date
          title
          text
          answersCount
          answers {
            id
            likesCount
            authorName
            date
            text
          }
        }
      }
      resort(${productArgs}) {
        icon
      }
     }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_COMMUNITY_QUESTIONS,
      strictErrors: false,
    });
  },
};
